import React, {useState, useEffect} from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import PropTypes from 'prop-types';
import {toTime, toTimeType, timeConverter, isObjectEmpty, uploadCSV, replaceAll, timeConverterSM} from '../../../../Utils';
import Spinner from '../../../common/generic/Spinner';
import axios from 'axios';

const ContainerComp = ({pageState, reportState, csvData, setcsvData, loadingLessonCount, setLoadingLessonCount}) =>{
    const [processedMarks, setProcessedMarks] = useState({});
    const [markRecords, setMarkRecords] = useState({});
    const {selectedStudents, selectedProgram} = reportState;
    const [lessonMarks, setLessonMarks] = useState({});
    const [loadingLessonReportCount, setLoadingLessonReportCount] = useState(-1);
    
    /*
    CSV NOTES
    =========
    There is a big problem when trying to upload more then 1 csv file.  The below system will reset all the data in 
    this component and start it over when when the user clicks save.
    
    Steps
    1) User clicks save in either ProgramReportTableComp or AcitivityReportComp
        1b) openCSVPage() will populate csvData using setcsvData({processStage:'newRequest'});
    2) ViewReportsPage checks to see if the marks have changed (* seems to be called way to many times...)
        2b) setReportType(csvData.reportType);
            setSelectedProgram({...csvData.selectedProgram});
            setSelectedStudents([...csvData.selectedStudents]); 
    3) Start the report
        3a) CSV Step 1: checks if a new request for csv and starts to clear the data
        3b) CSV Step 2: clears the data 
        3c) CSV Step 3: keep checking to see when the data has been cleared
        3d) CSV Step 4: once the data for this component has been reset then start the normal start up process for this comp.
        3e) (The normal Startup starts at CSV Step 1) 
    */

    // CSV Step 4: once the data for this component has been reset then start the normal start up process for this comp.
    // The normal Startup starts at CSV Step 1 
    const tryLoadingCSVStage2 = () => {
        if(!csvData) return;
        if(csvData.processStage === 'clearingData'){
            if(isObjectEmpty(lessonMarks) && isObjectEmpty(markRecords) && isObjectEmpty(processedMarks)){
                setcsvData({...csvData, processStage:'clearedData'});
            }
        }
    };
    // CSV Step 3: keep checking to see when the data has been cleared
    useEffect(() =>{tryLoadingCSVStage2();},[lessonMarks]);
    useEffect(() =>{tryLoadingCSVStage2();},[markRecords]);
    useEffect(() =>{tryLoadingCSVStage2();},[processedMarks]);

    // CSV Step 2: clears the data
    useEffect(() => {
        if(!csvData) return;

        if(csvData.processStage === 'clearingData'){
            setLessonMarks({});
            setMarkRecords({});
            setProcessedMarks({});
        }
    },[csvData]);


    const fetchLessonMarks = async (lessonQueries) => {
        //console.log('fetchLessonMarks loadingLessonCount',loadingLessonCount);
           
        if(typeof loadingLessonCount !=='undefined' && loadingLessonCount!==-1) return;
        if(typeof loadingLessonCount ==='undefined' && loadingLessonReportCount!==-1) return;

        let lessonData = [];
        if(typeof loadingLessonCount !=='undefined') setLoadingLessonCount(lessonQueries.length);
        if(typeof loadingLessonCount ==='undefined') setLoadingLessonReportCount(lessonQueries.length);

        //lessonQueries.forEach(lesson=>{
        for(let i=0; i< lessonQueries.length; i++){
            if(typeof loadingLessonCount !=='undefined') setLoadingLessonCount(lessonQueries.length-i);
            if(typeof loadingLessonCount ==='undefined') setLoadingLessonReportCount(lessonQueries.length-i);
            let response = await axios.post('https://m7a9wcdv0d.execute-api.us-east-1.amazonaws.com/dev',lessonQueries[i]);    
            lessonData.push(response.data.body.Items);
        }

        if(typeof loadingLessonCount !=='undefined') setLoadingLessonCount(-1);
        if(typeof loadingLessonCount ==='undefined') setLoadingLessonReportCount(-1);
         //console.log('lessonData',lessonData);

        let lessonFormated = {};
        lessonData.forEach(lessonRecs=>{
            lessonRecs.forEach(lessonRec=>{
                let studentID = lessonRec['StudentKey'].split('#')[0];
                if(!(studentID in lessonFormated)) lessonFormated[studentID]=[];
                lessonRec.Standard=lessonRec.Standard;
                lessonFormated[studentID].push(lessonRec);
            });
        });
        // console.log('lessonFormated',lessonFormated);

        setLessonMarks({data:lessonFormated});
    };

    // CSV Step 1: checks if a new request for csv and starts to clear the data 
    // Normal Startup Step 1:
    useEffect(() => {
        if(csvData){
            if(csvData.processStage==='newRequest'){
                // csvData.setloadingCSV({...csvData.loadingCSV, activity:true});
                setcsvData({...csvData, processStage:'clearingData'});
                return;
            }

            if(csvData.processStage==='clearingData') return;
        }

        if(isObjectEmpty(lessonMarks)){
            let reportData = JSON.parse(localStorage.getItem('reportData'));  
            let lessonQueries = selectedStudents.map(studentRec=>{                
                return {
                    SecurityTag: reportData.token,
                    DynamoDB:{
                        Query:'queryLessonMarksByStudentRead',
                        Criteria:{
                            ClassPart: `${reportData.classID}#LessonMark`,
                            StudentReadKey:`${studentRec.id}`
                        }
                    }        
                };
            });
            fetchLessonMarks(lessonQueries);
        }
    });

    useEffect(() => {
        if(csvData && csvData.processStage !== 'clearedData') return; // don't setup markRecords for csv files without being ready 
        if(isObjectEmpty(lessonMarks)) return;
        
        let marks = {};
        let key = 'unavailable';
        let studMarks = {};
        Object.keys(lessonMarks.data).forEach(key => {        
            marks = {
                isloaded: true,
                data: {[key]: lessonMarks.data[key]}
            }; 
            studMarks[key]=marks;
        });
        setMarkRecords(studMarks);
    }, [lessonMarks]);     

    useEffect(() =>{tryLoadingNow();},[markRecords]);
    const tryLoadingNow = () => {
        if(isObjectEmpty(lessonMarks)) return; // do we have the raw marks?
        if(isObjectEmpty(markRecords)) return; // do we have the raw marks converted to markRecords?
        if(!isObjectEmpty(processedMarks)) return; // We are trying to build the ProcessedMarks here        

        let reportData = JSON.parse(localStorage.getItem('reportData'));
        let masterLevel = parseInt(reportData.masterLevel)/100;

        // console.log('selectedStudents',selectedStudents,markRecords);
        let studentsLessonMarks = selectedStudents.reduce((acc,studentRec)=>{
            let studentID = studentRec.id;
            let studentMarkRecords = markRecords[studentID];            
            if(!studentMarkRecords) return acc; // still loading marks            
            acc[`${studentRec.id}+${studentRec.name}`] = studentMarkRecords.data[`${studentID}`];
            return acc;
        },{});

        Object.keys(studentsLessonMarks).forEach(key=>{
            let studentMarksByStandard = {};
            studentsLessonMarks[key].forEach(mark=>{
                if(!(mark.Standard in studentMarksByStandard)){
                    studentMarksByStandard[mark.Standard] ={
                        ClassPart: mark.ClassPart,
                        StudentKey: mark.StudentKey,
                        Standard: mark.Standard,
                        LessonName: mark.LessonName,
                        SchoolID: mark.SchoolID,
                        AssignedMasterLevel: mark.AssignedMasterLevel,
                        LessonID: mark.LessonID,
                        LessonKey: mark.LessonKey,
                        CompletedDate: '0',
                        CreationDate: '0',
                        QuestionsAttempted: 0,
                        QuestionsRight: 0,
                        AccumulatedTime: 0,
                        LastAccessedDate: '0',
                        TimesCompleted:0, 
                        TimesMastered:0, 
                    };                    
                }

                let score = Number(mark.QuestionsRight)/Number(mark.QuestionsAttempted);
                let wasMastered = score >= masterLevel;
                studentMarksByStandard[mark.Standard].TimesCompleted+=(mark.CompletedDate!=='0')?1:0;
                studentMarksByStandard[mark.Standard].TimesMastered+=(mark.CompletedDate!=='0' && wasMastered)?1:0;

                let lastAccessedDate = studentMarksByStandard[mark.Standard].LastAccessedDate;
                if(lastAccessedDate==='0') lastAccessedDate = mark.LastAccessedDate;
                if(lastAccessedDate > mark.LastAccessedDate) lastAccessedDate = mark.LastAccessedDate;

                //console.log('lastAccessedDate',lastAccessedDate);

                studentMarksByStandard[mark.Standard].QuestionsAttempted+=Number(mark.QuestionsAttempted);
                studentMarksByStandard[mark.Standard].QuestionsRight+=Number(mark.QuestionsRight);
                studentMarksByStandard[mark.Standard].AccumulatedTime+=Number(mark.AccumulatedTime);
                studentMarksByStandard[mark.Standard].LastAccessedDate = lastAccessedDate;
            });
            const array = Object.values(studentMarksByStandard);
            studentsLessonMarks[key]=array;
        });

        // console.log('studentsLessonMarks',studentsLessonMarks);

        setProcessedMarks(studentsLessonMarks);

        if(csvData){
            let newLine = '%0A';
            let csvString = '';
            csvString =`"* Each teacher can set their own mastery level for the class and an activity is considered to be mastered when the student answers at least that ${masterLevel*100}% of the questions correctly on any attempt"${newLine}`;
            csvString +=`"Student without marks will not appear in this report"${newLine}`;
            let tableHeaderStr = '"Last Used","Score","Time","Times Completed","Times Mastered","Standard"'+newLine;

            let name = '';
            if(Object.keys(studentsLessonMarks).length===1){
                name = Object.keys(studentsLessonMarks)[0].split('+')[1]+'_';
            }
    
            Object.keys(studentsLessonMarks).forEach(markKey => {
                let marks = studentsLessonMarks[markKey];
                let currentName = markKey.split('+')[1];

                let tmpTotals = {
                    Standard:'',
                    TimesCompleted:0, 
                    TimesMastered:0, 
                    QuestionsRight:0, 
                    QuestionsAttempted:0, 
                    AccumulatedTime:0, 
                    LastAccessedDate:'0'
                };                
                
                csvString += currentName+newLine;
                csvString += tableHeaderStr; 
                marks.forEach(mark=>{

                    const { Standard, TimesCompleted, TimesMastered, QuestionsRight, QuestionsAttempted, AccumulatedTime, LastAccessedDate} = mark;

                    if(!isNaN(TimesMastered)) tmpTotals.TimesMastered+=Number(TimesMastered); 
                    if(!isNaN(TimesCompleted)) tmpTotals.TimesCompleted+=Number(TimesCompleted); 
                    tmpTotals.QuestionsRight+=Number(QuestionsRight);
                    tmpTotals.QuestionsAttempted+=Number(QuestionsAttempted);
                    tmpTotals.AccumulatedTime+=Number(AccumulatedTime);
                    tmpTotals.Standard = '';

                    let markDate = '';
                    if(LastAccessedDate!=='0')
                        markDate = timeConverter(parseInt(LastAccessedDate));

                    let recordStr = `"${markDate}","${QuestionsRight}/${QuestionsAttempted} (${Math.round((QuestionsRight/QuestionsAttempted)*100)}%)","${toTime(AccumulatedTime)} ${toTimeType(AccumulatedTime)}","${TimesCompleted}","${TimesMastered}","${Standard}"${newLine}`;
                    csvString += recordStr;
                });
                let recordStr = `"Total","${tmpTotals.QuestionsRight}/${tmpTotals.QuestionsAttempted} (${Math.round((tmpTotals.QuestionsRight/tmpTotals.QuestionsAttempted)*100)}%)","${toTime(tmpTotals.AccumulatedTime)} ${toTimeType(tmpTotals.AccumulatedTime)}","${tmpTotals.TimesCompleted}","${tmpTotals.TimesMastered}","${tmpTotals.Standard}"${newLine}`;
                csvString += recordStr;
            });

            let today = new Date();
            today = timeConverterSM(today.getTime());
            uploadCSV(name+'LessonStandardsReport_'+selectedProgram.name+'_'+today,csvString);
            csvData.setloadingCSV({...csvData.loadingCSV, lessonMarks:false});
        }

    };     

    if(csvData) return <></>;    
    if(isObjectEmpty(lessonMarks)) return <> <Spinner/> <center>Loading...({loadingLessonReportCount}) </center> </>;
    return <>
        {Object.keys(processedMarks).length < selectedStudents.length && <center> <p>  Students without marks will not appear in this report </p></center>}
        {Object.keys(processedMarks).map((key, i) => (
            <span key={i}><br/> 
                <LessonBuilderStandardReportComp header={{student: key.split('+')[1], program: selectedProgram.name}} tableData={processedMarks[key]}/>            
            <br/></span>
        ))}
    </>;
};

const LessonBuilderStandardReportComp = ({header, tableData}) => {
    const [masterLevel, setMasterLevel] = useState(0.8);
    const [totals, setTotals] = useState({
        haveTotals:false,
        mark:{
            Standard:'',
            TimesCompleted:0, 
            TimesMastered:0, 
            QuestionsRight:0, 
            QuestionsAttempted:0, 
            AccumulatedTime:0, 
            LastAccessedDate:'0'
        }
    });

    useEffect(()=>{
        let reportData = JSON.parse(localStorage.getItem('reportData'));
        if(masterLevel !== (parseInt(reportData.masterLevel)/100))
            setMasterLevel(parseInt(reportData.masterLevel)/100);

        if(totals.haveTotals)
            return;
        let tmpTotals = {
            haveTotals:false,
            mark:{
                Standard:'',
                TimesCompleted:0, 
                TimesMastered:0, 
                QuestionsRight:0, 
                QuestionsAttempted:0, 
                AccumulatedTime:0, 
                LastAccessedDate:'0'
            }
        };

        tableData.map((markRec) => {
            if(!isNaN(markRec.TimesMastered)) tmpTotals.mark.TimesMastered+=Number(markRec.TimesMastered); 
            if(!isNaN(markRec.TimesCompleted)) tmpTotals.mark.TimesCompleted+=Number(markRec.TimesCompleted); 
            tmpTotals.mark.QuestionsRight+=Number(markRec.QuestionsRight);
            tmpTotals.mark.QuestionsAttempted+=Number(markRec.QuestionsAttempted);
            tmpTotals.mark.AccumulatedTime+=Number(markRec.AccumulatedTime);
        });
        setTotals({...tmpTotals.mark, haveTotals:true});
    });
    
    const titleRow = <Row style={{ fontSize:'0.9em', fontWeight:'bold'}}>
        <Col style={{textAlign: 'center'}} xs='2'>Last Used</Col>
        <Col style={{textAlign: 'center'}} xs='2'>Score</Col>
        <Col style={{textAlign: 'center'}} xs='2'>Time</Col>
        <Col style={{textAlign: 'center'}} xs='2'>Times Completed</Col>
        <Col style={{textAlign: 'center'}} xs='2'>Times Mastered</Col>
        <Col style={{textAlign: 'center'}} xs='2'>Standard</Col>
    </Row>;

    const headerComp = <center>
        <h4><Row>
            <Col xs='4'>{header.student}</Col> 
            <Col xs='4'> </Col>
            <Col xs='4'>Standard Report</Col>
        </Row></h4>
    </center>;

    const Footer = ()=> <center><hr/>* Each teacher can set their own mastery level for the class and an activity is considered to be mastered when the student answers at least that {masterLevel*100}% of the questions correctly on any attempt</center>;

    return (
        <>
            {headerComp}
            <hr/>
            {titleRow}

            {tableData.map((markRec, mark_i) => <TableRow key={mark_i} data={markRec} fontWeight={'normal'}/> )}
             <TableRow data={totals} fontWeight={'bold'}/>
            <Footer/>
        </>
    );
};

LessonBuilderStandardReportComp.propTypes = {
    tableData: PropTypes.array
};

const TableRow = (props) => {
    // console.log('props',props);
    const { Standard, TimesCompleted, TimesMastered, QuestionsRight, QuestionsAttempted, AccumulatedTime, LastAccessedDate } = props.data;
    
    const showDate=(theDate)=>{        
        if(theDate!=='0')
            return timeConverter(parseInt(theDate));
        return '';
    };

    return (
        <Row style={{fontSize:'0.9em'}}>
            {/* <Col style={{textAlign: 'center', fontWeight: props.fontWeight}} xs='2'>{LessonName}</Col> */}
            <Col style={{textAlign: 'center', fontWeight: props.fontWeight}} xs='2'>{showDate(LastAccessedDate)}</Col>
            <Col style={{textAlign: 'center', fontWeight: props.fontWeight}} xs='2'>{QuestionsRight}/{QuestionsAttempted} ({Math.round((QuestionsRight/QuestionsAttempted)*100)}%)</Col>
            <Col style={{textAlign: 'center', fontWeight: props.fontWeight}} xs='2'>{toTime(AccumulatedTime)} {toTimeType(AccumulatedTime)}</Col>
            <Col style={{textAlign: 'center', fontWeight: props.fontWeight}} xs='2'>{TimesCompleted}</Col>
            <Col style={{textAlign: 'center', fontWeight: props.fontWeight}} xs='2'>{TimesMastered}</Col>
            <Col style={{textAlign: 'center', fontWeight: props.fontWeight}} xs='2'>{Standard}</Col>
        </Row>
    );
};

TableRow.propTypes = {
    fontWeight: PropTypes.string,
    data: PropTypes.object
};
export default ContainerComp;